import React from "react";
import RelatedArticles from "@/components/ArticlePage/Components/RelatedArticles";
import { ArticlesByTag } from "@/components/PagePiller/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import routes from "@/helpers/router";
import { RegisterRefType } from "@/components/PageHome/interfaces";
import styles from "./ArticlesByTag.module.scss";

interface ArticlesByTagComponentProps {
  data: ArticlesByTag;
  userAgent: DeviceInfo;
  registerRef?: RegisterRefType;
  categorySlug?: string;
}

const ArticlesByTagComponent: React.FC<ArticlesByTagComponentProps> = ({
  data,
  userAgent,
  registerRef,
  categorySlug,
}) => {
  const { Title: title, ArticlesList, Tag } = data;
  const items = ArticlesList?.length > 0 ? ArticlesList : [];
  const { isMobile } = userAgent;

  return (
    <section
      data-ref_id={data?.refId}
      ref={(el) => {
        if (data?.ShowHeadingInIndex && registerRef && data?.refId) registerRef(data?.refId, el);
      }}
      className={`container ${styles.container} scrollMargin spacingBetweenSections`}
    >
      <RelatedArticles
        items={items}
        title={title}
        tags={[Tag]}
        ctaText={isMobile ? "Read more articles" : "View all articles"}
        // TODO: ctaURL: the user will land on the article listing page of the Tag under that particular pillar
        ctaURL={routes.resourcesListing("articles", categorySlug)}
        isCtaLink={isMobile}
        userAgent={userAgent}
      />
    </section>
  );
};

export default ArticlesByTagComponent;
